/**
 * Typed health/version API facade over the generated contract client.
 */

import { healthApi } from '../api/generated/health.api.js';

class HealthService {
  async getVersion(): Promise<{
    version: string;
    buildSha?: string;
    service: string;
    environment?: string;
  }> {
    return healthApi.getVersion() as Promise<{
      version: string;
      buildSha?: string;
      service: string;
      environment?: string;
    }>;
  }
}

export const healthService = new HealthService();
